/**
 * 시도 + 시군구 → 5자리 법정동코드(LAWD_CD) 매핑
 * 공공데이터포털 토지 실거래가 API에서 사용
 * 출처: 행정안전부 법정동코드 목록
 */
const MAP: Record<string, Record<string, string>> = {
  /* ──────────── 서울특별시 (11) ──────────── */
  서울특별시: {
    종로구: "11110", 중구: "11140", 용산구: "11170", 성동구: "11200",
    광진구: "11215", 동대문구: "11230", 중랑구: "11260", 성북구: "11290",
    강북구: "11305", 도봉구: "11320", 노원구: "11350", 은평구: "11380",
    서대문구: "11410", 마포구: "11440", 양천구: "11470", 강서구: "11500",
    구로구: "11530", 금천구: "11545", 영등포구: "11560", 동작구: "11590",
    관악구: "11620", 서초구: "11650", 강남구: "11680", 송파구: "11710",
    강동구: "11740",
  },
  /* ──────────── 부산광역시 (26) ──────────── */
  부산광역시: {
    중구: "26110", 서구: "26140", 동구: "26170", 영도구: "26200",
    부산진구: "26230", 동래구: "26260", 남구: "26290", 북구: "26320",
    해운대구: "26350", 사하구: "26380", 금정구: "26410", 강서구: "26440",
    연제구: "26470", 수영구: "26500", 사상구: "26530", 기장군: "26710",
  },
  /* ──────────── 대구광역시 (27) ──────────── */
  대구광역시: {
    중구: "27110", 동구: "27140", 서구: "27170", 남구: "27200",
    북구: "27230", 수성구: "27260", 달서구: "27290", 달성군: "27710",
    군위군: "27720",
  },
  /* ──────────── 인천광역시 (28) ──────────── */
  인천광역시: {
    중구: "28110", 동구: "28140", 미추홀구: "28177", 연수구: "28185",
    남동구: "28200", 부평구: "28237", 계양구: "28245", 서구: "28260",
    강화군: "28710", 옹진군: "28720",
  },
  /* ──────────── 광주광역시 (29) ──────────── */
  광주광역시: {
    동구: "29110", 서구: "29140", 남구: "29155", 북구: "29170",
    광산구: "29200",
  },
  /* ──────────── 대전광역시 (30) ──────────── */
  대전광역시: {
    동구: "30110", 중구: "30140", 서구: "30170", 유성구: "30200",
    대덕구: "30230",
  },
  /* ──────────── 울산광역시 (31) ──────────── */
  울산광역시: {
    중구: "31110", 남구: "31140", 동구: "31170", 북구: "31200",
    울주군: "31710",
  },
  /* ──────────── 세종특별자치시 (36) ──────────── */
  세종특별자치시: { 세종시: "36110" },
  /* ──────────── 경기도 (41) ──────────── */
  경기도: {
    "수원시 장안구": "41111", "수원시 권선구": "41113", "수원시 팔달구": "41115", "수원시 영통구": "41117",
    수원시: "41111",
    "성남시 수정구": "41131", "성남시 중원구": "41133", "성남시 분당구": "41135",
    성남시: "41131",
    의정부시: "41150",
    "안양시 만안구": "41171", "안양시 동안구": "41173",
    안양시: "41171",
    부천시: "41190", 광명시: "41210", 평택시: "41220", 동두천시: "41250",
    "안산시 상록구": "41271", "안산시 단원구": "41273",
    안산시: "41271",
    "고양시 덕양구": "41281", "고양시 일산동구": "41285", "고양시 일산서구": "41287",
    고양시: "41281",
    과천시: "41290", 구리시: "41310", 남양주시: "41360", 오산시: "41370",
    시흥시: "41390", 군포시: "41410", 의왕시: "41430", 하남시: "41450",
    "용인시 처인구": "41461", "용인시 기흥구": "41463", "용인시 수지구": "41465",
    용인시: "41461",
    파주시: "41480", 이천시: "41500", 안성시: "41550", 김포시: "41570",
    화성시: "41590", 광주시: "41610", 양주시: "41630", 포천시: "41650",
    여주시: "41670", 연천군: "41800", 가평군: "41820", 양평군: "41830",
  },
  /* ──────────── 강원특별자치도 (51) ──────────── */
  강원특별자치도: {
    춘천시: "51110", 원주시: "51130", 강릉시: "51150", 동해시: "51170",
    태백시: "51190", 속초시: "51210", 삼척시: "51230", 홍천군: "51720",
    횡성군: "51730", 영월군: "51750", 평창군: "51760", 정선군: "51770",
    철원군: "51780", 화천군: "51790", 양구군: "51800", 인제군: "51810",
    고성군: "51820", 양양군: "51830",
  },
  강원도: {
    춘천시: "51110", 원주시: "51130", 강릉시: "51150", 동해시: "51170",
    태백시: "51190", 속초시: "51210", 삼척시: "51230", 홍천군: "51720",
    횡성군: "51730", 영월군: "51750", 평창군: "51760", 정선군: "51770",
    철원군: "51780", 화천군: "51790", 양구군: "51800", 인제군: "51810",
    고성군: "51820", 양양군: "51830",
  },
  /* ──────────── 충청북도 (43) ──────────── */
  충청북도: {
    "청주시 상당구": "43111", "청주시 서원구": "43112", "청주시 흥덕구": "43113", "청주시 청원구": "43114",
    청주시: "43111",
    충주시: "43130", 제천시: "43150", 보은군: "43720", 옥천군: "43730",
    영동군: "43740", 증평군: "43745", 진천군: "43750", 괴산군: "43760",
    음성군: "43770", 단양군: "43800",
  },
  /* ──────────── 충청남도 (44) ──────────── */
  충청남도: {
    "천안시 동남구": "44131", "천안시 서북구": "44133",
    천안시: "44131",
    공주시: "44150", 보령시: "44180", 아산시: "44200", 서산시: "44210",
    논산시: "44230", 계룡시: "44250", 당진시: "44270", 금산군: "44710",
    부여군: "44760", 서천군: "44770", 청양군: "44790", 홍성군: "44800",
    예산군: "44810", 태안군: "44825",
  },
  /* ──────────── 전북특별자치도 (45) ──────────── */
  전북특별자치도: {
    "전주시 완산구": "45111", "전주시 덕진구": "45113",
    전주시: "45111",
    군산시: "45130", 익산시: "45140", 정읍시: "45180", 남원시: "45190",
    김제시: "45210", 완주군: "45710", 진안군: "45720", 무주군: "45730",
    장수군: "45740", 임실군: "45750", 순창군: "45770", 고창군: "45790",
    부안군: "45800",
  },
  전라북도: {
    "전주시 완산구": "45111", "전주시 덕진구": "45113",
    전주시: "45111",
    군산시: "45130", 익산시: "45140", 정읍시: "45180", 남원시: "45190",
    김제시: "45210", 완주군: "45710", 진안군: "45720", 무주군: "45730",
    장수군: "45740", 임실군: "45750", 순창군: "45770", 고창군: "45790",
    부안군: "45800",
  },
  /* ──────────── 전라남도 (46) ──────────── */
  전라남도: {
    목포시: "46110", 여수시: "46130", 순천시: "46150", 나주시: "46170",
    광양시: "46230", 담양군: "46710", 곡성군: "46720", 구례군: "46730",
    고흥군: "46770", 보성군: "46780", 화순군: "46790", 장흥군: "46800",
    강진군: "46810", 해남군: "46820", 영암군: "46830", 무안군: "46840",
    함평군: "46860", 영광군: "46870", 장성군: "46880", 완도군: "46890",
    진도군: "46900", 신안군: "46910",
  },
  /* ──────────── 경상북도 (47) ──────────── */
  경상북도: {
    "포항시 북구": "47111", "포항시 남구": "47113",
    포항시: "47111",
    경주시: "47130", 김천시: "47150", 안동시: "47170", 구미시: "47190",
    영주시: "47210", 영천시: "47230", 상주시: "47250", 문경시: "47280",
    경산시: "47290", 군위군: "47720", 의성군: "47730", 청송군: "47750",
    영양군: "47760", 영덕군: "47770", 청도군: "47820", 고령군: "47830",
    성주군: "47840", 칠곡군: "47850", 예천군: "47900", 봉화군: "47920",
    울진군: "47930", 울릉군: "47940",
  },
  /* ──────────── 경상남도 (48) ──────────── */
  경상남도: {
    "창원시 의창구": "48121", "창원시 성산구": "48123",
    "창원시 마산합포구": "48125", "창원시 마산회원구": "48127",
    "창원시 진해구": "48129",
    창원시: "48121",
    진주시: "48170", 통영시: "48220", 사천시: "48240", 김해시: "48250",
    밀양시: "48270", 거제시: "48310", 양산시: "48330", 의령군: "48720",
    함안군: "48730", 창녕군: "48740", 고성군: "48820", 남해군: "48840",
    하동군: "48850", 산청군: "48860", 함양군: "48870", 거창군: "48880",
    합천군: "48890",
  },
  /* ──────────── 제주특별자치도 (50) ──────────── */
  제주특별자치도: { 제주시: "50110", 서귀포시: "50130" },
};

/** 시도 약칭 → 정식명 */
const SIDO_ALIAS: Record<string, string> = {
  서울: "서울특별시", 부산: "부산광역시", 대구: "대구광역시",
  인천: "인천광역시", 광주: "광주광역시", 대전: "대전광역시",
  울산: "울산광역시", 세종: "세종특별자치시",
  경기: "경기도", 강원: "강원특별자치도", 충북: "충청북도",
  충남: "충청남도", 전북: "전북특별자치도", 전남: "전라남도",
  경북: "경상북도", 경남: "경상남도", 제주: "제주특별자치도",
};

/**
 * 시도 + 시군구 → 5자리 LAWD_CD 반환
 * 없으면 null
 */
export function getLawdCd(sido: string, sigungu: string): string | null {
  const normalSido = SIDO_ALIAS[sido] ?? sido;
  const districts = MAP[normalSido];
  if (!districts) return null;

  // 정확히 일치하면 바로 반환
  if (districts[sigungu]) return districts[sigungu];

  // 부분 일치 탐색 (예: "포항시 북구" ↔ "포항시")
  for (const [key, code] of Object.entries(districts)) {
    if (key.startsWith(sigungu) || sigungu.startsWith(key)) return code;
  }
  return null;
}

/**
 * 시군구에 해당하는 모든 LAWD_CD 반환 (복수 구청 시 여러 개)
 * 예: 포항시 → ["47111", "47113"]
 */
export function getAllLawdCds(sido: string, sigungu: string): string[] {
  const normalSido = SIDO_ALIAS[sido] ?? sido;
  const districts = MAP[normalSido];
  if (!districts) return [];

  const codes = new Set<string>();
  for (const [key, code] of Object.entries(districts)) {
    if (key === sigungu || key.startsWith(sigungu) || sigungu.startsWith(key.split(" ")[0])) {
      codes.add(code);
    }
  }
  return Array.from(codes);
}
